const addressSelectionTypesMap = {
  existintg: 'existing',
  new: 'new',
  same_as_shipping: 'same_as_shipping',
}
export default addressSelectionTypesMap
